import React, { useState } from "react";
import SeoHead from "../SiteSeo";
import SiteLayout from "../SiteLayout";
import { SmartLink } from "../SiteHeader";
import { FinalCta } from "../sections";
import { TOOLS, CATEGORIES } from "./tools";

// Hub — structure per reference (Flow): featured tool, life-stage filter tabs, one card per tool on its own URL.
export default function CalculatorsHub() {
  const [cat, setCat] = useState("all");
  const featured = TOOLS.find((t) => t.slug === "affordability");
  const list = TOOLS.filter((t) => cat === "all" || t.category === cat);
  return (
    <SiteLayout>
      <SeoHead title="Free Mortgage Calculators Alberta | Hello Mortgage Team" description="Mortgage payment, affordability, closing costs, renewal, refinance and rent-vs-buy calculators built on real Canadian lending rules — pre-filled with today’s rates." path="/calculators/" />
      <section className="calc-hero" data-testid="calculators-hub">
        <div className="wrap">
          <div className="eyebrow">Mortgage calculators</div>
          <h1>Just here for the math? We respect that.</h1>
          <p>Real Canadian mortgage math, already loaded with today’s rates. Play with the numbers as much as you like — nobody’s watching, and nobody’s asking for your email.</p>
        </div>
      </section>
      <section className="calc-featured"><div className="wrap">
        <SmartLink className="featured-tool" href={`/calculators/${featured.slug}/`} data-testid="hub-featured-tool">
          <div><span className="tag">Featured tool</span><h2 className="display">{featured.tagline}</h2><p>{featured.blurb}</p><span className="btn">Open the {featured.name.toLowerCase()} calculator</span></div>
          <div className="featured-stats"><div className="stat"><strong>39% / 44%</strong><span>GDS / TDS limits applied</span></div><div className="stat"><strong>+2%</strong><span>stress test built in</span></div><div className="stat"><strong>60s</strong><span>to a real answer</span></div></div>
        </SmartLink>
      </div></section>
      <section className="calc-list"><div className="wrap">
        <div className="calc-tabs" role="tablist" aria-label="Filter calculators">
          {[["all", "All tools"], ...CATEGORIES].map(([k, l]) => <button key={k} role="tab" type="button" aria-selected={cat === k} className={cat === k ? "active" : ""} onClick={() => setCat(k)} data-testid={`hub-tab-${k}`}>{l}</button>)}
        </div>
        <div className="tool-grid" data-testid="hub-tool-grid">
          {list.map((t) => <SmartLink className="tool" href={`/calculators/${t.slug}/`} key={t.slug} data-testid={`hub-tool-${t.slug}`}><span className="tag">{CATEGORIES.find(([k]) => k === t.category)[1]}</span><h3>{t.tagline}</h3><p>{t.blurb}</p><div className="fine">Free · Private · No signup</div><div className="tool-link">{t.name} calculator →</div></SmartLink>)}
        </div>
      </div></section>
      <FinalCta text="Calculators are useful starting points. A strategy conversation includes the lender rules and details a calculator can’t see. No pressure. No mortgage-speak." />
    </SiteLayout>
  );
}
